<template>
  <div id="app-div" style="overflow-y: hidden">
    <div class="top">
      <div class="search_icon">
        <span style="margin-left: 10px">
          <img src="../../../../assets/u3220.png" class="icon_img" />
          筛选查询
        </span>
      </div>
      <div class="query_div">
        <a-row>
          <a-col :span="5">
            <label for="roleName">角色名称：</label>
            <a-input
              placeholder="请输入"
              v-model="queryRoleName"
              id="roleName"
              class="query_input"
            />
          </a-col>
          <a-button type="primary" class="query_btn" @click="query">
            查询
          </a-button>
          <a-button
            type="primary"
            style="margin-left: 10px"
            @click="() => addMethod('add')"
            >新增</a-button
          >
        </a-row>
      </div>
    </div>
    <div class="middle">
      <div style="float: left; margin-left: 10px">
        <img src="../../../../assets/u3227.png" class="icon_img" />
        <span>&nbsp;数据列表</span>
      </div>
      <div class="sortType" style="float: right">
        排序方式：
        <a-select
          size="small"
          defaultValue="1"
          style="width: 120px"
          @change="sortChange"
          v-model="sort"
        >
          <a-select-option value="1">编号降序</a-select-option>
          <a-select-option value="2">编号升序</a-select-option>
          <a-select-option value="3">时间降序</a-select-option>
          <a-select-option value="4">时间升序</a-select-option>
        </a-select>
      </div>
    </div>
    <div class="bottom" id="bottom">
      <div class="table_box">
        <a-table
          :pagination="false"
          :rowSelection="rowSelection"
          :columns="columns"
          :dataSource="data"
          :rowKey="(record) => record.roleCode"
          size="small"
          :scroll="{ y: data.length < 8 ? false : table_height }"
          bordered
        >
          <span slot="operator" slot-scope="text, record">
            <a
              href="javascript:void(0);"
              @click="() => permissionSetting(record.roleCode)"
              >权限设置</a
            >
            <a-divider type="vertical" />
            <a
              href="javascript:void(0);"
              @click="() => checkRoleMethod(record, 'check')"
              >查看</a
            >
            <a-divider type="vertical" />
            <a
              href="javascript:void(0);"
              @click="() => editRoleMethod(record, 'edit')"
              >编辑</a
            >
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => changeStatus(record, 1)"
              >启用</a
            >
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => changeStatus(record, 0)"
              >禁用</a
            >
            <a-divider type="vertical" />
            <a
              href="javascript:void(0);"
              @click="() => deleteRole(record.roleCode)"
              >删除</a
            >
          </span>
          <span slot="status" slot-scope="text, record">
            <label v-if="record.status == '1'">
              <img class="status_img" src="../../../../assets/open.png" />已启用
            </label>
            <label v-if="record.status == '0'">
              <img
                class="status_img"
                src="../../../../assets/close.png"
              />已禁用
            </label>
          </span>
        </a-table>
      </div>
      <div id="components-pagination-demo-mini">
        <a-pagination
          :total="total"
          :showTotal="(total) => `共 ${total} 条`"
          showSizeChanger
          showQuickJumper
          :pageSizeOptions="pageSizeOptions"
          :defaultPageSize="limit"
          @showSizeChange="onShowSizeChange"
          @change="pageChange"
        />
      </div>
      <a-select
        defaultValue="0"
        class="batch_operation"
        @change="operateChange"
        v-model="operateCode"
      >
        <a-select-option value="0">批量操作</a-select-option>
        <a-select-option value="1">批量导出</a-select-option>
        <a-select-option value="2">批量禁用</a-select-option>
        <a-select-option value="3">批量启用</a-select-option>
      </a-select>
    </div>
    <a-modal
      :title="title"
      v-model="visible"
      width="600px"
      @cancel="cancel"
      @ok="enSure"
      :centered="true"
      :maskClosable="false"
    >
      <template>
        <div class="role-edit">
          <a-row>
            <a-col :span="4" class="title">
              <span style="color: red">*</span>角色名称：
            </a-col>
            <a-col :span="8">
              <a-input
                v-model="roleInfo.roleName"
                v-bind:read-only="isEnable"
                placeholder="请输入"
              />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="4" class="title">角色描述：</a-col>
            <a-col :span="16">
              <a-textarea
                v-model="roleInfo.roleDesc"
                v-bind:read-only="isEnable"
                placeholder="请输入"
                :autosize="{ minRows: 3, maxRows: 6 }"
              />
            </a-col>
          </a-row>
        </div>
      </template>
    </a-modal>

    <a-modal
      title="查看"
      v-model="checkVisible"
      width="400px"
      :footer="null"
      :centered="true"
      :maskClosable="false"
    >
      <template>
        <div class="role-edit">
          <a-row>
            <a-col :span="10" class="title"> 角色名称： </a-col>
            <a-col :span="12" style="margin-top: 5px">
              {{ roleInfo.roleName }}
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="10" class="title">角色描述：</a-col>
            <a-col :span="12" style="margin-top: 5px">
              {{ roleInfo.roleDesc }}
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="10" class="title">状态：</a-col>
            <a-col :span="12" style="margin-top: 5px">
              <label v-if="roleInfo.status == 1">启用</label>
              <label v-if="roleInfo.status == 0">禁用</label>
            </a-col>
          </a-row>
        </div>
      </template>
    </a-modal>
    <a-modal
      title="提示"
      v-model="delVisible"
      @ok="deleteOk"
      :centered="true"
      width="300px"
      :maskClosable="false"
    >
      <p>确认删除吗？</p>
    </a-modal>
  </div>
</template>


<script>
const columns = [
  {
    title: "角色名称",
    dataIndex: "roleName",
    width: 140,
  },
  {
    title: "角色描述",
    dataIndex: "roleDesc",
  },
  {
    title: "状态",
    dataIndex: "status",
    width: 100,
    scopedSlots: { customRender: "status" },
  },
  {
    title: "创建者",
    dataIndex: "creater",
    width: 120,
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
  },
  {
    title: "操作",
    key: "operator",
    width: 320,
    scopedSlots: { customRender: "operator" },
  },
];

const data = [];

import qs from "qs";
export default {
  name: "checkRole",
  data() {
    return {
      serviceAddress: this.$config.serviceAddress,
      data,
      columns,
      selectedRowKeys: [],
      visible: false,
      checkVisible: false,
      roleInfo: { roleCode: "", roleName: "", roleDesc: "", status: 1 },
      isEnable: false,
      title: "查看",
      currentMode: "check",
      delVisible: false,
      delRoleCode: "",
      queryRoleName: "",
      sort: "1",
      sortField: "role_code",
      sortType: "desc",
      operateCode: "0",
      page: 1,
      limit: 20,
      total: 0,
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      table_height: 0,
    };
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        columnWidth: 35,
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,
        onSelection: this.onSelection,
      };
    },
  },
  created() {
    this.query();
  },
  mounted() {
    //设置bottom高度
    var height = document.body.clientHeight;
    var bottom_height = height - 230;
    var bottom = document.getElementById("bottom");
    bottom.style.height = bottom_height + "px";
    this.table_height = bottom_height - 100;
  },
  methods: {
    onShowSizeChange(current, pageSize) {
      this.page = current;
      this.limit = pageSize;
      this.query();
    },
    pageChange(pageNumber) {
      this.page = pageNumber;
      this.query();
    },
    sortChange() {
      if (this.sort == 1) {
        this.sortField = "role_code";
        this.sortType = "desc";
      } else if (this.sort == 2) {
        this.sortField = "role_code";
        this.sortType = "";
      } else if (this.sort == 3) {
        this.sortField = "create_time";
        this.sortType = "desc";
      } else if (this.sort == 4) {
        this.sortField = "create_time";
        this.sortType = "";
      }
      this.query();
    },
    operateChange() {
      var itemLegth = this.selectedRowKeys.length;
      if (itemLegth == 0) {
        this.utils.messageInfo(this, "error", "最少选择一条数据！");
        return;
      }
      if (this.operateCode == 1) {
        if (this.serviceAddress == "") {
          this.utils.messageInfo(
            this,
            "error",
            "获取后台ip地址失败，无法导出！"
          );
          return;
        }
        var selectedRowKeys = this.selectedRowKeys;
        window.open(
          this.serviceAddress +
            "/roleMenu/exportData?codeArr=" +
            selectedRowKeys +
            ""
        );
      } else if (this.operateCode == 2) {
        this.batchChangeStatus(0);
      } else if (this.operateCode == 3) {
        this.batchChangeStatus(1);
      }
    },
    batchChangeStatus(status) {
      this.axios
        .post("/roleMenu/changeStatus", {
          status: status,
          codes: JSON.stringify(this.selectedRowKeys),
        })
        .then((res) => {
          if (res.data.code == "OK") {
            if (status == "0") {
              this.utils.messageInfo(this, "success", "禁用成功！");
            } else {
              this.utils.messageInfo(this, "success", "启用成功！");
            }
            this.query();
          } else {
            this.utils.messageInfo(this, "error", "操作失败！");
          }
        });
    },
    query() {
      this.axios
        .get("/roleMenu/queryRoles", {
          params: {
            roleName: this.queryRoleName,
            sortField: this.sortField,
            sortType: this.sortType,
            page: this.page,
            limit: this.limit,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.total = res.data.count;
            this.data = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询角色列表失败！");
          }
        });
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    permissionSetting(roleCode) {
      this.$router.push({ path: "/roleSet", query: { roleCode: roleCode } });
    },
    addMethod(type) {
      this.roleInfo = { status: 1 };
      this.isEnable = false;
      this.visible = true;
      this.title = "新增";
      this.currentMode = type;
    },
    checkRoleMethod(obj) {
      this.roleInfo = {
        roleCode: obj.roleCode,
        roleName: obj.roleName,
        roleDesc: obj.roleDesc,
        status: obj.status,
      };
      this.checkVisible = true;
    },
    editRoleMethod(obj, type) {
      this.roleInfo = {
        roleCode: obj.roleCode,
        roleName: obj.roleName,
        roleDesc: obj.roleDesc,
        status: obj.status,
      };
      this.isEnable = false;
      this.visible = true;
      this.title = "编辑";
      this.currentMode = type;
    },
    changeStatus(obj, status) {
      this.axios
        .post("/roleMenu/update", {
          roleCode: obj.roleCode,
          status: status,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            if (status == "0") {
              this.utils.messageInfo(this, "success", "禁用成功！");
            } else {
              this.utils.messageInfo(this, "success", "启用成功！");
            }
            for (var i = 0; i < this.data.length; i++) {
              if (this.data[i].roleCode == obj.roleCode) {
                this.data[i].status = status;
              }
            }
            this.visible = false;
          } else {
            this.utils.messageInfo(this, "error", "编辑失败！");
          }
        });
    },
    deleteRole(roleCode) {
      this.delVisible = true;
      this.delRoleCode = roleCode;
    },
    deleteOk() {
      this.axios
        .post("/roleMenu/delete", {
          roleCode: this.delRoleCode,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "删除成功");
            this.delVisible = false;
            this.query();
          } else {
            this.utils.messageInfo(this, "error", "删除失败！");
          }
        });
    },
    cancel() {
      this.visible = false;
    },
    enSure() {
      if (this.currentMode == "check") {
        this.visible = false;
      } else if (this.currentMode == "edit") {
        if (this.roleInfo.roleName == "") {
          this.utils.messageInfo(this, "error", "角色名不能为空！");
          return;
        }
        this.axios
          .post("/roleMenu/update", {
            roleCode: this.roleInfo.roleCode,
            roleName: this.roleInfo.roleName,
            roleDesc: this.roleInfo.roleDesc,
          })
          .then((res) => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "编辑成功");
              this.query();
              this.visible = false;
            } else {
              this.utils.messageInfo(this, "error", "编辑失败！");
            }
          });
      } else if (this.currentMode == "add") {
        if (this.roleInfo.roleName == "") {
          this.utils.messageInfo(this, "error", "角色名不能为空！");
          return;
        }
        this.axios
          .post("/roleMenu/insert", {
            roleName: this.roleInfo.roleName,
            roleDesc: this.roleInfo.roleDesc,
            status: this.roleInfo.status,
            creater: sessionStorage.getItem("userCode"),
          })
          .then((res) => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "添加成功");
              this.query();
              this.visible = false;
            } else {
              this.utils.messageInfo(this, "error", "添加失败！");
            }
          });
      }
    },
  },
};
</script>
<style>
@import "../../../../assets/css/PageCss.css";
</style>
<style scoped>
.role-edit .ant-row {
  margin-bottom: 10px;
}
.role-edit .title {
  text-align: right;
  line-height: 32px;
}
.status_img {
  width: 18px;
  margin-right: 6px;
  margin-bottom: 3px;
}
</style>
